const API = process.env.REACT_APP_API_URL || 'http://localhost:3090';

async function api(path, options = {}) {
  const res = await fetch(`${API}${path}`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...options.headers },
    ...options,
  });
  // console.log('res: ', res);
  if (!res.ok) {
    if (res.status === 401) {
      window.location.href = `${API}/auth/login`;
      return new Promise(() => {}); // зависаємо — сторінка ось-ось піде на перезавантаження
    }
    const error = await res.json().catch(() => ({ message: res.statusText }));
    throw { status: res.status, ...error };
  }
  const contentType = res.headers.get('content-type');

  if (res.status == 204){
    return {};
  }

  return res.json();
}

// Warehouses
export const getWarehouses = () => api('/warehouses');
export const getWarehouse = (id) => api(`/warehouses/${id}`);
export const createWarehouse = (data) => api('/warehouses', { method: 'POST', body: JSON.stringify(data) });
export const updateWarehouse = (id, data) => api(`/warehouses/${id}`, { method: 'PUT', body: JSON.stringify(data) });
export const deleteWarehouse = (id) => api(`/warehouses/${id}`, { method: 'DELETE' });
export const toggleWarehouseDeletionMark = (id) => api(`/warehouses/${id}/deletion-mark`, { method: 'PATCH' });
export const hardDeleteWarehouse = (id) => api(`/warehouses/${id}/hard`, { method: 'DELETE' });
export const exportWarehouses = () => api('/warehouses/export');
export const importWarehouses = (data) => api('/warehouses/import', { method: 'POST', body: JSON.stringify(data) });

// Warehouse delivery defaults (one per carrier + delivery mode; carrierId is a
// query param — a mode-scoped path segment stays reserved for `mode` itself)
export const getWarehouseDeliveryDefaults = (warehouseId) =>
  api(`/warehouses/${warehouseId}/delivery-defaults`);
export const upsertWarehouseDeliveryDefault = (warehouseId, carrierId, mode, data) =>
  api(`/warehouses/${warehouseId}/delivery-defaults/${mode}?carrierId=${encodeURIComponent(carrierId)}`, { method: 'PUT', body: JSON.stringify(data) });
export const deleteWarehouseDeliveryDefault = (warehouseId, carrierId, mode) =>
  api(`/warehouses/${warehouseId}/delivery-defaults/${mode}?carrierId=${encodeURIComponent(carrierId)}`, { method: 'DELETE' });

// Directions
export const getDirections = () => api('/directions');
export const getDirection = (id) => api(`/directions/${id}`);
export const createDirection = (data) => api('/directions', { method: 'POST', body: JSON.stringify(data) });
export const updateDirection = (id, data) => api(`/directions/${id}`, { method: 'PUT', body: JSON.stringify(data) });
export const deleteDirection = (id) => api(`/directions/${id}`, { method: 'DELETE' });
export const toggleDirectionDeletionMark = (id) => api(`/directions/${id}/deletion-mark`, { method: 'PATCH' });
export const hardDeleteDirection = (id) => api(`/directions/${id}/hard`, { method: 'DELETE' });

// Statuses (global catalog)
export const getStatuses = () => api('/statuses');
export const createStatus = (data) => api('/statuses', { method: 'POST', body: JSON.stringify(data) });
export const updateStatus = (id, data) => api(`/statuses/${id}`, { method: 'PATCH', body: JSON.stringify(data) });
export const toggleStatusDeletionMark = (id) => api(`/statuses/${id}/deletion-mark`, { method: 'PATCH' });
export const deleteStatus = (id) => api(`/statuses/${id}`, { method: 'DELETE' });
export const exportStatuses = () => api('/statuses/export');
export const importStatuses = (data) => api('/statuses/import', { method: 'POST', body: JSON.stringify(data) });

// Carriers (global catalog)
export const getCarriers = () => api('/carriers');
export const createCarrier = (data) => api('/carriers', { method: 'POST', body: JSON.stringify(data) });
export const updateCarrier = (id, data) => api(`/carriers/${id}`, { method: 'PATCH', body: JSON.stringify(data) });
export const toggleCarrierDeletionMark = (id) => api(`/carriers/${id}/deletion-mark`, { method: 'PATCH' });
export const deleteCarrier = (id) => api(`/carriers/${id}`, { method: 'DELETE' });
export const exportCarriers = () => api('/carriers/export');
export const importCarriers = (data) => api('/carriers/import', { method: 'POST', body: JSON.stringify(data) });

export const uploadCarrierLogo = async (carrierId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const res = await fetch(`${API}/carriers/${carrierId}/logo`, {
    method: 'POST',
    credentials: 'include',
    body: formData,
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw { status: res.status, ...body };
  }
  return res.json();
};

export const deleteCarrierLogo = (carrierId) => api(`/carriers/${carrierId}/logo`, { method: 'DELETE' });

// App enabled statuses
export const updateAppEnabledStatuses = (slug, enabledStatuses) =>
  api(`/apps/${slug}/enabled-statuses`, { method: 'PATCH', body: JSON.stringify({ enabledStatuses }) });

// Direction members
export const getDirectionMembers = (id) => api(`/directions/${id}/members`);
export const addDirectionMember = (id, data) => api(`/directions/${id}/members`, { method: 'POST', body: JSON.stringify(data) });
export const removeDirectionMember = (id, userId) => api(`/directions/${id}/members/${userId}`, { method: 'DELETE' });

// Users
export const getUsers = () => api('/users');
export const getUser = (id) => api(`/users/${id}`);
export const updateUser = (id, data) => api(`/users/${id}`, { method: 'PATCH', body: JSON.stringify(data) });
export const assignUserRole = (userId, data) => api(`/users/${userId}/roles`, { method: 'POST', body: JSON.stringify(data) });
export const removeUserRole = (userId, directionId) => api(`/users/${userId}/roles/${directionId}`, { method: 'DELETE' });
export const getOnecUserCandidates = (id) => api(`/users/${id}/onec-candidates`);
export const deleteUser = (id) => api(`/users/${id}`, { method: 'DELETE' });
export const blockUser = (id, blocked) => api(`/users/${id}`, { method: 'PATCH', body: JSON.stringify({ isActive: !blocked }) });

// Job Titles
export const getJobTitles = () => api('/job-titles');
export const createJobTitle = (data) => api('/job-titles', { method: 'POST', body: JSON.stringify(data) });
export const updateJobTitle = (id, data) => api(`/job-titles/${id}`, { method: 'PUT', body: JSON.stringify(data) });
export const deleteJobTitle = (id) => api(`/job-titles/${id}`, { method: 'DELETE' });
export const toggleJobTitleDeletionMark = (id) => api(`/job-titles/${id}/deletion-mark`, { method: 'PATCH' });
export const hardDeleteJobTitle = (id) => api(`/job-titles/${id}/hard`, { method: 'DELETE' });
export const exportJobTitles = () => api('/job-titles/export');
export const importJobTitles = (data) => api('/job-titles/import', { method: 'POST', body: JSON.stringify(data) });

// Departments
export const getDepartments = () => api('/departments');
export const createDepartment = (data) => api('/departments', { method: 'POST', body: JSON.stringify(data) });
export const updateDepartment = (id, data) => api(`/departments/${id}`, { method: 'PUT', body: JSON.stringify(data) });
export const deleteDepartment = (id) => api(`/departments/${id}`, { method: 'DELETE' });
export const toggleDepartmentDeletionMark = (id) => api(`/departments/${id}/deletion-mark`, { method: 'PATCH' });
export const hardDeleteDepartment = (id) => api(`/departments/${id}/hard`, { method: 'DELETE' });

// Counterparties
export const getCounterparties = () => api('/counterparties');
export const searchCounterparties = (q) => api(`/counterparties/search?q=${encodeURIComponent(q)}`);
/** Точний пошук за ЄДРПОУ/ІПН (сервер прибирає пробіли й дефіси); порожній ключ — [] без запиту. */
export const findCounterpartiesByEdrpou = (edrpou) => {
  const key = String(edrpou ?? '').replace(/[\s-]+/g, '');
  return key ? api(`/counterparties/search?edrpou=${encodeURIComponent(key)}`) : Promise.resolve([]);
};
/** Швидке створення (name + edrpou/code); 409 з `existing: { id, name }`, якщо ЄДРПОУ вже є. */
export const quickCreateCounterparty = (data) => api('/counterparties/quick-create', { method: 'POST', body: JSON.stringify(data) });
export const getCounterparty = (id) => api(`/counterparties/${id}`);
/** Прив'язує картку до GUID 1С; 409 DUPLICATE/CONFLICT, якщо GUID уже зайнятий або в картки інший. */
export const linkCounterpartyOnec = (id, onecId) => api(`/counterparties/${id}/onec-link`, { method: 'POST', body: JSON.stringify({ onecId }) });
/** Підтягує адресу з відкритого реєстру за ЄДРПОУ картки; поле лише для читання. */
export const refreshCounterpartyRegistryAddress = (id) => api(`/counterparties/${id}/registry-address`, { method: 'POST' });
export const createCounterparty = (data) => api('/counterparties', { method: 'POST', body: JSON.stringify(data) });
export const updateCounterparty = (id, data) => api(`/counterparties/${id}`, { method: 'PUT', body: JSON.stringify(data) });
export const deleteCounterparty = (id) => api(`/counterparties/${id}`, { method: 'DELETE' });
export const toggleCounterpartyDeletionMark = (id) => api(`/counterparties/${id}/deletion-mark`, { method: 'PATCH' });
export const hardDeleteCounterparty = (id) => api(`/counterparties/${id}/hard`, { method: 'DELETE' });

// Counterparty contacts
export const getCounterpartyContacts = (id) => api(`/counterparties/${id}/contacts`);
export const createCounterpartyContact = (id, data) => api(`/counterparties/${id}/contacts`, { method: 'POST', body: JSON.stringify(data) });
export const updateCounterpartyContact = (counterpartyId, contactId, data) => api(`/counterparties/${counterpartyId}/contacts/${contactId}`, { method: 'PUT', body: JSON.stringify(data) });
export const deleteCounterpartyContact = (counterpartyId, contactId) => api(`/counterparties/${counterpartyId}/contacts/${contactId}`, { method: 'DELETE' });

// Counterparty bank accounts
export const getCounterpartyBankAccounts = (id) => api(`/counterparties/${id}/bank-accounts`);
export const createCounterpartyBankAccount = (id, data) => api(`/counterparties/${id}/bank-accounts`, { method: 'POST', body: JSON.stringify(data) });
export const updateCounterpartyBankAccount = (counterpartyId, accountId, data) => api(`/counterparties/${counterpartyId}/bank-accounts/${accountId}`, { method: 'PUT', body: JSON.stringify(data) });
export const deleteCounterpartyBankAccount = (counterpartyId, accountId) => api(`/counterparties/${counterpartyId}/bank-accounts/${accountId}`, { method: 'DELETE' });

// НБУ: пошук банку за МФО (для автопідстановки назви банку у формі рахунку)
export const lookupBankByMfo = (mfo) => api(`/integrations/nbu/bank-by-mfo/${mfo}`);

// Currencies (global catalog)
export const getCurrencies = () => api('/currencies');

// Contact persons (reference)
export const getContactPersons = () => api('/contact-persons');
export const searchContactPersons = (q) => api(`/contact-persons/search?q=${encodeURIComponent(q)}`);
/** Пошук контактної особи в 1С за телефоном (SPARK не має чого шукати — 1С не вміє пошук за ім'ям). */
export const lookupContactPersonOnec = (phone) => api(`/contact-persons/lookup-onec?phone=${encodeURIComponent(phone)}`);
/** Історія дзвінків з номера в PBX (+ ім'я з Caller ID, якщо АТС його захопила) — третє джерело умного пошуку. */
export const lookupContactPersonPbx = (phone) => api(`/contact-persons/lookup-pbx?phone=${encodeURIComponent(phone)}`);
export const getContactPerson = (id) => api(`/contact-persons/${id}`);
export const createContactPerson = (data) => api('/contact-persons', { method: 'POST', body: JSON.stringify(data) });
export const updateContactPerson = (id, data) => api(`/contact-persons/${id}`, { method: 'PUT', body: JSON.stringify(data) });
export const deleteContactPerson = (id) => api(`/contact-persons/${id}`, { method: 'DELETE' });

// Contact info (belongs to ContactPerson)
export const getContactInfo = (personId) => api(`/contact-persons/${personId}/info`);
export const createContactInfo = (personId, data) => api(`/contact-persons/${personId}/info`, { method: 'POST', body: JSON.stringify(data) });
export const updateContactInfo = (personId, infoId, data) => api(`/contact-persons/${personId}/info/${infoId}`, { method: 'PUT', body: JSON.stringify(data) });
export const deleteContactInfo = (personId, infoId) => api(`/contact-persons/${personId}/info/${infoId}`, { method: 'DELETE' });

// Створення контактної особи разом з телефоном/email і, за потреби, прив'язкою до контрагента.
// Використовується там, де контактна особа створюється "на льоту" (inline) — ContactPersonSelect,
// кнопка "Додати" в заявці, форма створення контактної особи з НП.
export async function createContactPersonWithInfo({
  lastName,
  firstName,
  middleName,
  code,
  description,
  phone,
  phoneCategory = 'WORK',
  email,
  emailCategory = 'WORK',
  counterpartyId,
  deliveryFlag = false,
}) {
  const finalDescription = (description || [lastName, firstName, middleName].filter(Boolean).join(' ')).trim();

  const person = await createContactPerson({
    lastName: lastName?.trim() || undefined,
    firstName: firstName?.trim() || undefined,
    middleName: middleName?.trim() || undefined,
    code: code?.trim() || undefined,
    description: finalDescription,
  });

  const phoneValue = phone?.trim();
  if (phoneValue && person.id) {
    try {
      await createContactInfo(person.id, {
        category: phoneCategory,
        type: 'PHONE',
        presentation: phoneValue,
        isDefault: true,
      });
    } catch (_) {
      // non-critical — person created, phone is optional
    }
  }

  const emailValue = email?.trim();
  if (emailValue && person.id) {
    try {
      await createContactInfo(person.id, {
        category: emailCategory,
        type: 'EMAIL',
        presentation: emailValue,
        isDefault: true,
      });
    } catch (_) {
      // non-critical — person created, email is optional
    }
  }

  if (counterpartyId) {
    await createCounterpartyContact(counterpartyId, {
      contactPersonId: person.id,
      description: finalDescription,
      comment: deliveryFlag ? 'DELIVERY' : '',
    });
  }

  return person;
}

/**
 * Редагування "на льоту" — EditContactPersonModal. Оновлює базові поля й лише той
 * телефон/email, що були показані у формі (`phoneInfoId`/`emailInfoId` з initialData) —
 * інші наявні contactInfo не чіпає. Порожнє значення при наявному info-id — видаляє запис.
 */
export async function updateContactPersonWithInfo({
  id,
  lastName,
  firstName,
  middleName,
  description,
  phone,
  phoneCategory = 'WORK',
  phoneInfoId,
  email,
  emailCategory = 'WORK',
  emailInfoId,
}) {
  const finalDescription = (description || [lastName, firstName, middleName].filter(Boolean).join(' ')).trim();

  const person = await updateContactPerson(id, {
    lastName: lastName?.trim() || undefined,
    firstName: firstName?.trim() || undefined,
    middleName: middleName?.trim() || undefined,
    description: finalDescription,
  });

  const phoneValue = phone?.trim();
  if (phoneValue) {
    await (phoneInfoId
      ? updateContactInfo(id, phoneInfoId, { category: phoneCategory, type: 'PHONE', presentation: phoneValue, isDefault: true })
      : createContactInfo(id, { category: phoneCategory, type: 'PHONE', presentation: phoneValue, isDefault: true })
    ).catch(() => {});
  } else if (phoneInfoId) {
    await deleteContactInfo(id, phoneInfoId).catch(() => {});
  }

  const emailValue = email?.trim();
  if (emailValue) {
    await (emailInfoId
      ? updateContactInfo(id, emailInfoId, { category: emailCategory, type: 'EMAIL', presentation: emailValue, isDefault: true })
      : createContactInfo(id, { category: emailCategory, type: 'EMAIL', presentation: emailValue, isDefault: true })
    ).catch(() => {});
  } else if (emailInfoId) {
    await deleteContactInfo(id, emailInfoId).catch(() => {});
  }

  return person;
}

// Organizations
export const getOrganizations = () => api('/organizations');
export const createOrganization = (data) => api('/organizations', { method: 'POST', body: JSON.stringify(data) });
export const updateOrganization = (id, data) => api(`/organizations/${id}`, { method: 'PUT', body: JSON.stringify(data) });
export const deleteOrganization = (id) => api(`/organizations/${id}`, { method: 'DELETE' });
export const toggleOrganizationDeletionMark = (id) => api(`/organizations/${id}/deletion-mark`, { method: 'PATCH' });
export const hardDeleteOrganization = (id) => api(`/organizations/${id}/hard`, { method: 'DELETE' });

// Phone numbers (nested under user)
export const createPhoneNumber = (userId, data) => api(`/users/${userId}/phones`, { method: 'POST', body: JSON.stringify(data) });
export const updatePhoneNumber = (userId, phoneId, data) => api(`/users/${userId}/phones/${phoneId}`, { method: 'PUT', body: JSON.stringify(data) });
export const deletePhoneNumber = (userId, phoneId) => api(`/users/${userId}/phones/${phoneId}`, { method: 'DELETE' });

// Messengers (nested under phone)
export const createMessenger = (userId, phoneId, data) => api(`/users/${userId}/phones/${phoneId}/messengers`, { method: 'POST', body: JSON.stringify(data) });
export const deleteMessenger = (userId, phoneId, messengerId) => api(`/users/${userId}/phones/${phoneId}/messengers/${messengerId}`, { method: 'DELETE' });

// Organization roles (nested under user)
export const assignOrgRole = (userId, data) => api(`/users/${userId}/organization-roles`, { method: 'POST', body: JSON.stringify(data) });
export const removeOrgRole = (userId, orgId) => api(`/users/${userId}/organization-roles/${orgId}`, { method: 'DELETE' });

// Status transition permissions
export const getTransitionPermissions = (appSlug) => api(`/apps/${appSlug}/status-transition-permissions`);
export const createTransitionPermission = (appSlug, data) => api(`/apps/${appSlug}/status-transition-permissions`, { method: 'POST', body: JSON.stringify(data) });
export const updateTransitionPermission = (appSlug, id, data) => api(`/apps/${appSlug}/status-transition-permissions/${id}`, { method: 'PUT', body: JSON.stringify(data) });
export const deleteTransitionPermission = (appSlug, id) => api(`/apps/${appSlug}/status-transition-permissions/${id}`, { method: 'DELETE' });
export const resetTransitionPermissions = (appSlug) => api(`/apps/${appSlug}/status-transition-permissions/reset`, { method: 'POST' });
export const exportTransitionPermissions = (appSlug) => api(`/apps/${appSlug}/status-transition-permissions/export`);
export const importTransitionPermissions = (appSlug, data) => api(`/apps/${appSlug}/status-transition-permissions/import`, { method: 'POST', body: JSON.stringify(data) });

// Product Types
export const getProductTypes = () => api('/product-types');
export const getProductTypesByOrganization = (orgId) => api(`/product-types/by-organization/${orgId}`);
export const createProductType = (data) => api('/product-types', { method: 'POST', body: JSON.stringify(data) });
export const updateProductType = (id, data) => api(`/product-types/${id}`, { method: 'PUT', body: JSON.stringify(data) });
export const deleteProductType = (id) => api(`/product-types/${id}`, { method: 'DELETE' });
export const toggleProductTypeDeletionMark = (id) => api(`/product-types/${id}/deletion-mark`, { method: 'PATCH' });
export const hardDeleteProductType = (id) => api(`/product-types/${id}/hard`, { method: 'DELETE' });
export const exportProductTypes = () => api('/product-types/export');
export const importProductTypes = (data) => api('/product-types/import', { method: 'POST', body: JSON.stringify(data) });

// ── Permission System (Apps / Assignments) ──
export const getApps = () => api('/apps');
export const getAppBySlug = (slug) => api(`/apps/${slug}`);
export const getAppAssignments = (slug) => api(`/apps/${slug}/assignments`);
export const createAssignment = (data) => api('/apps/assignments', { method: 'POST', body: JSON.stringify(data) });
export const deleteAssignment = (id) => api(`/apps/assignments/${id}`, { method: 'DELETE' });
export const assignRoleToUser = (data) => api('/apps/assign-role', { method: 'POST', body: JSON.stringify(data) });
export const unassignRoleFromUser = (data) => api('/apps/unassign-role', { method: 'POST', body: JSON.stringify(data) });

// Email Settings
export const getEmailSettings = () => api('/email-settings');
export const updateEmailSettings = (data) => api('/email-settings', { method: 'PUT', body: JSON.stringify(data) });
export const sendTestEmail = (to) => api('/email-settings/test', { method: 'POST', body: JSON.stringify({ to }) });
export const getNotificationLogs = (status) => api(`/email-settings/logs?status=${encodeURIComponent(status || 'QUEUE')}`);
export const retryNotificationLogs = () => api('/email-settings/logs/retry', { method: 'POST' });

// System settings (Система → Загальні): автооновлення даних з 1С у зверненнях
export const getSystemSettings = () => api('/system-settings');
export const updateSystemSettings = (data) => api('/system-settings', { method: 'PUT', body: JSON.stringify(data) });
export const runOnecAutoSync = () => api('/system-settings/onec-sync/run', { method: 'POST' });
export const runInvoiceSync = () => api('/system-settings/invoice-sync/run', { method: 'POST' });
export const runInquiryAutoShipped = () => api('/system-settings/inquiry-auto-shipped/run', { method: 'POST' });

// Doc preview settings (предпросмотр документов: LibreOffice/ONLYOFFICE)
export const getDocPreviewSettings = () => api('/doc-preview-settings');
export const updateDocPreviewSettings = (data) => api('/doc-preview-settings', { method: 'PUT', body: JSON.stringify(data) });
// Доступно будь-якому користувачу (не ADMIN) — фронт вирішує, показувати превью офісних документів чи скачування
export const getDocPreviewStatus = () => api('/doc-preview-settings/status');

// Desktop releases (.msi) — дистрибуція десктопної версії.
// Шляхи БЕЗ префікса /api: він вже входить в API (REACT_APP_API_URL, напр.
// http://localhost:3090/api), тож додавати його тут не можна — інакше буде /api/api/...
export const uploadDesktopInstaller = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const res = await fetch(`${API}/admin/desktop/releases`, {
    method: 'POST',
    credentials: 'include',
    body: formData,
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw { status: res.status, ...body };
  }
  return res.json();
};

export const getDesktopReleases = () => api('/admin/desktop/releases');

export const deleteDesktopRelease = (id) => api(`/admin/desktop/releases/${id}`, { method: 'DELETE' });
